export const SHIFT_PLAN_PAGE_ROOT_ID = 'shift-plan-root-page'
